import { ReactComponent as ItalicIcon } from 'assets/icons/italic24.svg'
import cx from 'classnames'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useItalicToggle } from 'common/Prose/Toolbar/hooks/useItalicToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { observer } from 'mobx-react-lite'
import Styles from '../../MobileToolbar.module.scss'

export const ItalicMark = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active, disabled, handleClick } = useItalicToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Set italic"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active,
        [Styles.disabled]: disabled,
      })}
      onPress={handleClick}
      data-testid="mobile-toolbar-italic-mark"
      {...props}
    >
      <ItalicIcon />
    </Button>
  )
})
